import { ImportStage } from "../workflows/ImportStage";

export function isCompleted(stage: ImportStage): boolean {
  return stage === "complete" || stage === "backgroundImporting";
}
